import { useState } from 'react';

const useHover = () => {
  const [hover, setHover] = useState(false);
  const [coords, setCoords] = useState({ top: 0 });

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setCoords({ top: rect.top - 4 });

    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  return { hover, coords, handleMouseEnter, handleMouseLeave };
};

export default useHover;
